// extracted by mini-css-extract-plugin
export default {"card":"D1dDJrMescOlJwf7tV_Y","replace":"drP04rzW8ws2mjKuFROV","active":"wDEuboZ2WRAQ_EGxML3v","droparea":"gI4ZzCycN0HHjaKHlsnH"};